module.exports = __webpack_public_path__ + "img/paragraph-solid.dfa14294.svg";